// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3AVvw","footer":"ModalError_footer__1vBCk"};